import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="select-kit-header-wrapper">
  {{#each this.icons as |icon|}}
    {{d-icon icon}}
  {{/each}}

  {{#if this.selectKit.options.useHeaderFilter}}
    <div class="select-kit-header--filter">
      {{#if this.selectedContent.length}}
        {{#each this.selectedContent as |item|}}
          {{component
            this.selectKit.options.selectedChoiceComponent
            item=item
            selectKit=this.selectKit
          }}
        {{/each}}
      {{/if}}

      {{component
        this.selectKit.options.filterComponent
        selectKit=this.selectKit
        id=(concat this.selectKit.uniqueID "-filter")
        hidePlaceholderWithSelection=true
      }}
    </div>
  {{else}}
    <MultiSelect::FormatSelectedContent
      @content={{or this.selectedContent this.selectKit.noneItem}}
      @selectKit={{this.selectKit}}
    />

    {{d-icon this.caretIcon class="caret-icon"}}
  {{/if}}
</div>
*/
{
  "id": "iRibAE3O",
  "block": "[[[10,0],[14,0,\"select-kit-header-wrapper\"],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,0,[\"icons\"]]],null]],null],null,[[[1,\"    \"],[1,[28,[35,2],[[30,1]],null]],[1,\"\\n\"]],[1]],null],[1,\"\\n\"],[41,[30,0,[\"selectKit\",\"options\",\"useHeaderFilter\"]],[[[1,\"    \"],[10,0],[14,0,\"select-kit-header--filter\"],[12],[1,\"\\n\"],[41,[30,0,[\"selectedContent\",\"length\"]],[[[42,[28,[37,1],[[28,[37,1],[[30,0,[\"selectedContent\"]]],null]],null],null,[[[1,\"          \"],[46,[30,0,[\"selectKit\",\"options\",\"selectedChoiceComponent\"]],null,[[\"item\",\"selectKit\"],[[30,2],[30,0,[\"selectKit\"]]]],null],[1,\"\\n\"]],[2]],null]],[]],null],[1,\"\\n      \"],[46,[30,0,[\"selectKit\",\"options\",\"filterComponent\"]],null,[[\"selectKit\",\"id\",\"hidePlaceholderWithSelection\"],[[30,0,[\"selectKit\"]],[28,[37,5],[[30,0,[\"selectKit\",\"uniqueID\"]],\"-filter\"],null],true]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,6],null,[[\"@content\",\"@selectKit\"],[[28,[37,7],[[30,0,[\"selectedContent\"]],[30,0,[\"selectKit\",\"noneItem\"]]],null],[30,0,[\"selectKit\"]]]],null],[1,\"\\n\\n    \"],[1,[28,[35,2],[[30,0,[\"caretIcon\"]]],[[\"class\"],[\"caret-icon\"]]]],[1,\"\\n\"]],[]]],[13]],[\"icon\",\"item\"],false,[\"each\",\"-track-array\",\"d-icon\",\"if\",\"component\",\"concat\",\"multi-select/format-selected-content\",\"or\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/multi-select/multi-select-header.hbs",
  "isStrictMode": false
});